// Maps sidebar menu/path prefix → module key used by tenant-level feature flags.
// Super Admin (platform role) bypasses this entirely — they never see business menus.
// Menus not listed here are ALWAYS shown (e.g., Dashboard, Profile, Notifications).
export const MODULE_KEY_BY_LABEL = {
  Payroll: 'payroll',
  Attendance: 'attendance',
  Leave: 'leave',
  Statutory: 'statutory',
  Employees: 'employees',
  Reports: 'reports',
  Finance: 'finance',
  Analytics: 'analytics',
  'Travel Desk': 'travel_desk',
};

// Maps frontend route prefix → module key. Used by ModuleGate to block direct URL access.
export const MODULE_KEY_BY_PATH_PREFIX = [
  { prefix: '/payroll', key: 'payroll' },
  { prefix: '/attendance', key: 'attendance' },
  { prefix: '/leave', key: 'leave' },
  { prefix: '/statutory', key: 'statutory' },
  { prefix: '/employees', key: 'employees' },
  { prefix: '/reports', key: 'reports' },
  { prefix: '/finance', key: 'finance' },
  { prefix: '/analytics', key: 'analytics' },
  { prefix: '/travel', key: 'travel_desk' },
];

export const isModuleEnabled = (user, moduleKey) => {
  if (!moduleKey) return true;
  if (user?.role === 'super_admin') return true;
  const enabled = user?.enabled_modules;
  if (!Array.isArray(enabled)) return true; // backward compatible
  return enabled.includes(moduleKey);
};
